import { useMutation } from "@tanstack/react-query";
import { useNotification } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { BookCategory } from "@modules/bookCategories/types";
import { BookCategoryFormValues } from "@modules/bookCategories/validations";

import { createBookCategoryService } from "./service";
import { UseCreateCategoryMutationOptions } from "./types";

export function useCreateBookCategoryMutation(
  options?: UseCreateCategoryMutationOptions
) {
  const { open } = useNotification();

  return useMutation<BookCategory, ApiError, BookCategoryFormValues>({
    mutationFn: createBookCategoryService,
    onError: (error: ApiError) => {
      open?.({
        type: "error",
        message: error.response.data.error,
      });
    },
    ...options,
  });
}
